import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import ExpertInfo from "@components/expertSection/ExpertInfoExpanded";
import ExpertJourneyPage from "@components/pageTypes/ExpertJourneyPage";
import useSubscribeToJourney from "@hooks/subscriptions/useSubscribeToJourney";
import {
  GetJourneyWithExpertDocument,
  GetJourneyWithExpertQuery,
  GetJourneyWithExpertQueryVariables
} from "@typing/Generated";

type Props = {
  expertId: string;
  journeyId: string;
};

const ExpertJourneyExpertInfoPage = ({ expertId, journeyId }: Props) => {
  const getJourneyQuery = useQuery<GetJourneyWithExpertQuery, GetJourneyWithExpertQueryVariables>(
    GetJourneyWithExpertDocument,
    {
      variables: { id: journeyId }
    }
  );

  useSubscribeToJourney(journeyId, () => {
    getJourneyQuery.refetch();
  });

  const currentExpert = useMemo(
    () => getJourneyQuery.data?.journey.expertRoles?.find(role => role.expert.id === expertId)?.expert,
    [getJourneyQuery.data?.journey.expertRoles, expertId]
  );

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.expert.show" journeyId={journeyId}>
      <>{currentExpert && <ExpertInfo expert={currentExpert} journeyId={journeyId} />}</>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyExpertInfoPage;
